export function parseSearchParam() {
  const params = new URLSearchParams(window.location.search);
  return {
    studyPlanId: params.get('spid'),
    lessonId: params.get('lid'),
    topicId: params.get('tid'),
    source: params.get('src'),
    searchQueryId: params.get('sqid'),
    recPosition: params.get('recpos'),
  };
}
